import { EventCalendar } from '@/types/Calendar'
import { ChildWithParents } from '@/types/Child'
import { Moment } from 'moment'
import { momentDaytime } from '../../models/common'

export function hasConflictingSlot(
    child: ChildWithParents,
    events: EventCalendar[],
    date: string,
    startTime: string,
    endTime: string
): boolean {
    return events.some((event) => {
        if (event.childId !== child.id) return false

        const start: Moment = momentDaytime(event.start)
        return (
            start.format('DD-MM-YYYY') === date &&
            start.format('HH:mm') < endTime &&
            momentDaytime(event.end).format('HH:mm') > startTime
        )
    })
}
